// src/services/BaseCostService.js

export const DEFAULT_COST_CONFIG = {
  NI_MULTIPLIER: 1.138, // 13.8%
  OVERHEAD_MULTIPLIER: 1.10, // 10%
  FIXED_PENSION_COST_PER_HOUR: 1.29,
};

export class BaseCostService {
  constructor(config = DEFAULT_COST_CONFIG) {
    this.config = { ...DEFAULT_COST_CONFIG, ...config };
  }

  calculateTrueCostPerHour(hourlyRate) {
    const { NI_MULTIPLIER, OVERHEAD_MULTIPLIER, FIXED_PENSION_COST_PER_HOUR } = this.config;
    
    // Apply NI + overhead multiplier to base rate
    const adjustedRate = hourlyRate * NI_MULTIPLIER * OVERHEAD_MULTIPLIER;
    
    // Add fixed pension cost per hour
    return adjustedRate + FIXED_PENSION_COST_PER_HOUR;
  }

  // Configuration methods
  getConfig() {
    return { ...this.config };
  }

  updateConfig(newConfig) {
    this.config = { ...this.config, ...newConfig };
  }

  // Static access to default config
  static DEFAULT_COST_CONFIG = DEFAULT_COST_CONFIG;
}